// we leave en messages as it is
export default {
  'Basic Configuration': 'Basic',
  'Advanced Configuration': 'Advanced',
  'Connection Configuration': 'Connection',
  'Download original': 'Original',
  'Task #{0} {1} failed: {2}': 'Task #{0} {1} failed: {2}',
  'RPC Error: {0}': 'RPC Error: {0}',
  '"{0}" is not a valid proxy string': '"{0}" is not a valid proxy string',
  '"{0}" is not a valid error number': '"{0}" is not a valid error number',
  'Successfully add task #{0}': 'Successfully add task #{0}',
  'This WebUI don\'t supports xeHentai earlier than {0}': 'This WebUI don\'t supports xeHentai earlier than {0}'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en-us.js